export default __webpack_public_path__ + "static/media/content_tab03_3_02.5329e461.jpg";